import { render, staticRenderFns } from "./PokerCard.vue?vue&type=template&id=7287a966&scoped=true&"
import script from "./PokerCard.vue?vue&type=script&lang=js&"
export * from "./PokerCard.vue?vue&type=script&lang=js&"
import style0 from "./PokerCard.vue?vue&type=style&index=0&id=7287a966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7287a966",
  null
  
)

export default component.exports